<template>

<div :id="component_data.id" class="custom05">
    <section class="custom05_section mobile:hide">
        <div class="custom05_wrapper font-responsive">
            <div class="custom05_contents" :style="'background-image: url('+component_data.params.bg+');'">
                <h2 class="onimage_heading" v-html="component_data.params.vid_title"></h2>
                <img class="custom05_img mobile:hide" :src="component_data.params.img.src" :alt="component_data.params.img.alt">
                <video-block v-if="component_data.params.vid" :component_data="component_data.params.vid">
                    <button class="playButton btn_reset mobile:hide"><svg viewBox="0 0 320 320" version="1.1" ><circle cx="160" cy="160" r="158" class="a"/><path d="M141,198l50,-37.5l-50,-37.5l0,75Z" class="b"/></svg></button>
                </video-block>
            </div>
        </div>
    </section>
    <div class="feat_wrapper font-responsive">
        <div class="feat_contents w-5/6 mobile:w-full mobile:flex-column mx-auto">
         <div class="feat_visual w-1/2 mobile:w-full">
             <div class="feat_photo-big no_video">
                 <img class="tab_photo-big--inner" :src="component_data.params.img2.src" :alt="component_data.params.img2.alt">
            </div>
        </div>
        <article class="feat_caption w-1/3 mobile:w-full mobile-sides">
           <header>
                    <h2 v-html="component_data.params.title"></h2>
                </header>
                <div class="feat_texts">
                    <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
                </div>
            </article>
        </div>
    </div>
</div>
</template>

<script>
import video from '@/components/videoBlock/video_bodyless' 
export default {
    props: ['component_data'],
    data(){
        return {
            playing: false,
            returning: false,
            firstPlay: true,


        }
    },
    methods: {
        startAnimation(){            
        },

    },
    mounted(){

    },
    created(){

    },
    components: {
        "video-block": video
    }
}
</script>

<style>
    .custom05_section {
        overflow: visible;
    }

    .custom05_wrapper {
        position: relative;
        width: 83.3%;
        margin: 0 auto 0 8.33%;
    }

    .custom05_wrapper::before {
        content: "";
        display:block;
        padding-bottom:43.11%;
        width: 100%;
    }
    .custom05_contents {
        position: absolute;            
        display: flex;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;          
        background-color: grey;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-top-right-radius: 6em;
    }
    .custom05_contents::after {
        content: '';
        opacity: .7;
        margin-left: 40%;
        position: absolute;
        left: 0;
        top: 79%;
        width: 5.39vw;
        height: 17.7vw; 
        
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAABG2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+Gkqr6gAAAYJpQ0NQc1JHQiBJRUM2MTk2Ni0yLjEAACiRdZHPK0RRFMc/hmnkR6NYWFhMwsqIEbGxGPlVWIynDDYzb+bNqJnxeu9JslW2ihIbvxb8BWyVtVJESjY21sQGPefNm5pJ5tzOPZ/7vfec7j0XPEpGzZpV3ZDNWUZkLByYi84HfC948eOjj+aYaupTM6MKZe3zngon3gadWuXP/Wu1iaSpQkW18JCqG5bwuPDkqqU7vCPcpKZjCeEz4U5DLih85+hxl18dTrn87bChRIbB0yAcSJVwvITVtJEVlpfTls2sqIX7OC+pS+ZmZyS2irdgEmGMMAEmGGGYfnoYlLmfICG6ZEWZ/O58/jTLkqvKrLOGwRIp0lh0iroi1ZMSNdGTMjKsOf3/21dT6w251evC4H227fd28G3Dz5Ztfx3Z9s8xVD7BZa6Yv3wIAx+ibxW1tgPwb8D5VVGL78LFJjQ/6jEjlpcqxT2aBm+nUB+FxhuoWXB7Vtjn5AGUdfmqa9jbhw4571/8BXIaZ+uidZaVAAAACXBIWXMAAAsTAAALEwEAmpwYAAABu0lEQVR4nO3aMUpjURSH8S+OC1B45YNBK592M7MAsXABUw/YuwQXkA0M2AesXUAGZBYwTieviwivfJDBfswU9wopHIR3vLwI368KJ8nhcpJzk+IPkiRJkiRJescmkTd3VfMN2AUu6779m2sfgHNgWfftVfyIg882AfaBL7n0C1jUfbuK9N0OnmsX+ArsdFUzzbUL4AS4DvYeLA/rDPi4Vj4AHrqqmUWGFh3YJbBDGtBWrh0DN/m5seyThnUHzHPtFDgC9oDF0MZbr7/k//IaToGfpE/0LD+ePq/oSD4BK2Be9+1j3bePwI9c+xxpHBrYOxC6o18SWsl8wV+Q1nCWy8fAU1c1Y37LfgOHwGlXNesrOQFuI42jd9g56f66Ia0mwFOu/QG+B/sPtQAeSENrcm2Sa/eRxtGBLUm/hut/K6akYS2DvQer+3bVVc2MdME/31m3wH30b4UkSZIkSZIkSZIkSZKksYQTeqXSysEzFUt3RxOIxdLKQcXS3dFAXbG0clCxdHc0FFwsrRxRMt39VinqN08rb6roShZLK0eUTHdHB1YsrRxULN0dGtgGp5U3Mt0tSZIkSZKk0f0DPQ+0TxuRMJUAAAAASUVORK5CYII=') 0 0 / 3.958vw 3.958vw,        
                    url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAABG2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+Gkqr6gAAAYJpQ0NQc1JHQiBJRUM2MTk2Ni0yLjEAACiRdZHPK0RRFMc/hmnkR6NYWFhMwsqIEbGxGPlVWIynDDYzb+bNqJnxeu9JslW2ihIbvxb8BWyVtVJESjY21sQGPefNm5pJ5tzOPZ/7vfec7j0XPEpGzZpV3ZDNWUZkLByYi84HfC948eOjj+aYaupTM6MKZe3zngon3gadWuXP/Wu1iaSpQkW18JCqG5bwuPDkqqU7vCPcpKZjCeEz4U5DLih85+hxl18dTrn87bChRIbB0yAcSJVwvITVtJEVlpfTls2sqIX7OC+pS+ZmZyS2irdgEmGMMAEmGGGYfnoYlLmfICG6ZEWZ/O58/jTLkqvKrLOGwRIp0lh0iroi1ZMSNdGTMjKsOf3/21dT6w251evC4H227fd28G3Dz5Ztfx3Z9s8xVD7BZa6Yv3wIAx+ibxW1tgPwb8D5VVGL78LFJjQ/6jEjlpcqxT2aBm+nUB+FxhuoWXB7Vtjn5AGUdfmqa9jbhw4571/8BXIaZ+uidZaVAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmUlEQVR4nO3aMUrcQRTH8e/beAA9gWgVk854ALHwAKmF9B7BA3iBgP1Cag+g4AmSdLYrniDBXp/FjGAhBPbt8F/D91O+3R2Gt2+GKX4gSZIkSZKkdywqP87ME2ALuIiIx177AJwCfyLiR32LS+8tgF3goJd+AouIyMq6G8V9bQFfgc3MPO+1M+AIuCyuvbTerG/A9qvyR+A+M+eVplUbdgFs0ho067VD4KZ/NpVdWrNugateOwY+AzvAYtmFSw2LiMc+WTPaPwowB85fjuhE9oEEriLiASAzr4FPwBcKDZv9+yvvWumOfktpwvoFf0Y7hvNePgSeMnPKKftNm6bjzHx9JAP4VVm4eoed0u6vG+Dl0n/qtb/A9+L6y1oA97Sm7fVa9NpdZeH//VmxQ7uzoE3WXfVZIUmSJEmSJEmSJEmSJGkq5YTeqLRycU/DYljVBOKwtHLRsHR3NYE4LK1cNCzdXW3YsLRyxch096pS1CtPK6+r6oQNSytXjEx3Vxs2LK1cNCzdvapnxVqlldc53S1JkiRJkqRJPQNxpLfLzduddwAAAABJRU5ErkJggg==') 0 0 / 3.958vw 3.958vw;        
    }

    .custom05 .feat_photo-big::before {
        content: '';
        margin-left: 40%;
        position: absolute;
        opacity: .5;
        left: 45%;
        bottom: 65%;
        width: calc(100vw * (234/1920));
        height: calc(100vw * (315/1920)); 
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAABG2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+Gkqr6gAAAYJpQ0NQc1JHQiBJRUM2MTk2Ni0yLjEAACiRdZHPK0RRFMc/hmnkR6NYWFhMwsqIEbGxGPlVWIynDDYzb+bNqJnxeu9JslW2ihIbvxb8BWyVtVJESjY21sQGPefNm5pJ5tzOPZ/7vfec7j0XPEpGzZpV3ZDNWUZkLByYi84HfC948eOjj+aYaupTM6MKZe3zngon3gadWuXP/Wu1iaSpQkW18JCqG5bwuPDkqqU7vCPcpKZjCeEz4U5DLih85+hxl18dTrn87bChRIbB0yAcSJVwvITVtJEVlpfTls2sqIX7OC+pS+ZmZyS2irdgEmGMMAEmGGGYfnoYlLmfICG6ZEWZ/O58/jTLkqvKrLOGwRIp0lh0iroi1ZMSNdGTMjKsOf3/21dT6w251evC4H227fd28G3Dz5Ztfx3Z9s8xVD7BZa6Yv3wIAx+ibxW1tgPwb8D5VVGL78LFJjQ/6jEjlpcqxT2aBm+nUB+FxhuoWXB7Vtjn5AGUdfmqa9jbhw4571/8BXIaZ+uidZaVAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrklEQVR4nO3aPWtUURAG4GcTBYsgCmIlShSCX6CdpRokP8BasBd/gb2WNoK9ha1gJxbBxtIigpbxA9IJBitTaCzOlaQT7+xhN/A+5ezeKc6dM9ziJSIiIiIiIiIiDrDF4vN3cB3vsLuv532s4H2xf8UE57CGy/iJ7WrTQ8Xnj+M2juHRUHuAVbwo9q6Y4C7O7Kudxxc8s/dy/1v1wJ5qh7WKhaF2A+vDb7NyVjusD3g91NZwCcvYHNu4eiV38RantTd6FS/xEL+KvStu4QSe4wd2sIVrOIyPYxsv/PsvB9pk2g2rE7ao7ayb2mRtaFfylDZ5o3dF0Q6u4Kg2WUe0K3kSr/B9bOPqDrun7a91e0v/91DbxpNi/7E2tQV/EReG2mSofao0rk7YCj7jsbaz/u60Je0tzvKzYgNftZ31TZusN2Y39RERERERERERERERERERERERUVKNO9EprVzULd1dDdR1SysXdUt3Vw+sW1q5qFu6u3olu6WVi7qlu6eVop56WnleVSesW1q5qFu6u7rDuqWVi7qlu6fxWTGPaeV5TndHRERERERERMTs/AHq0275lImCnwAAAABJRU5ErkJggg==') 0 0 / 3.958vw 3.958vw;
        
    }
    .custom05_contents::before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        border-top-right-radius: 6em;
        overflow: hidden;
        background-image:linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,.2) 60%, rgba(0,0,0,.7));
    }
    .custom05_icon {
        margin: 0;
    }
    .custom05_icon svg {
        width: 10em;
        height: 10em;
        border-radius: 8px;
        color: white;
        background-color: #E41429;
        margin: 0;
    }
    .custom05_img {
        max-width: 100%;
        width: 30%;
        margin-left: 10%;
        position: absolute;
        left: 0;
        top: 63%;
        border-top-left-radius: 6em;
    }
    .custom05_wrapper::after { 
        border-bottom-left-radius: 6em;
    }


</style>
<style scoped>
    .feat_contents {
        flex-direction: row-reverse;
    }
    .playButton {
        width: 28em;
        height: 28em;
        cursor: pointer;
        position: absolute;
        top: 6em;
        left: 23em;
    }
    .a{fill:none;stroke:#fff;stroke-width:4px;stroke-dasharray:20;transform-origin: 160px 160px;transition: transform .3s linear;}.b{fill:#e41429;transform-origin: 160px 160px;transition: transform .3s linear;}

    .playButton:hover .a{
        transform: rotate(360deg) scale(.9);
        transition: transform .8s cubic-bezier(.17,.67,.69,2);
    }
    .playButton:hover .b{
        transform: scale(1.1);
        transition: transform .6s cubic-bezier(.17,.67,.69,2);
    }

    .feat_caption {
        padding: 0;
        justify-content: start;
        margin-right: 6.67%;
    }

    h2.onimage_heading {
        color: white;
        font-weight: 700;
        font-size: 5.8em; 
        width: 40%;
        position: absolute;
        left: 50%;
        bottom: .7em;
    }

    .feat_caption h2 {
        margin: calc(1.13 * 0.3 * 0.83 * 0.5 * 100vw) 0 0;
    }
    .feat_texts {
        padding: 0;
    }

    .feat_photo-big {
        width: calc(2 * 37.5vw);
        height: calc(2 * 41.6vw);
    }   

    @media (min-width: 992px){
        .feat_photo-big {
            width: 37.5vw;
            height: 41.6vw;
            margin-right: 20%;
        }    
    }
    @media (min-width: 1920px){
        .feat_photo-big {
            width: 720px;
            height: 800px;
        }      
    }
    .feat_wrapper::before { 
        display: none;
    }

    .feat_visual {
        align-items: flex-end;
        overflow: visible;
    }
</style>